import { mat4ComposeInto } from './mat4-compose-into.js';
import { allocateMat4 } from './_matrix-allocator.js';

function mat4Compose(tx, ty, tz, qx, qy, qz, qw, sx, sy, sz) {
  const out = allocateMat4();
  mat4ComposeInto(out, 0, tx, ty, tz, qx, qy, qz, qw, sx, sy, sz);
  return out;
}

export { mat4Compose };
//# sourceMappingURL=mat4-compose.js.map
